import React from 'react';
import { ProfileStep2 } from 'components/newAccountSteps/profileSteps/profileStep2/profileStep2';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { CardSelectorViewContainer } from 'components/newAccountSteps/profileSteps/cardSelectorView/cardSelectorViewContainer';
import { PinCardView } from 'components/newAccountSteps/profileSteps/pinCardView/pinCardView';
import { DEBIT_CARD, DEBIT_CARD_PIN } from 'constants/statusProcess';

export const CountriesNotSpainView = ({ status, products }) => {
    if (status === DEBIT_CARD) {
        return (
            <div>
                <CardSelectorViewContainer products={products} />
                <WelcomeCard />
            </div>
        );
    }
    if (status === DEBIT_CARD_PIN) {
        return (
            <div>
                <PinCardView products={products} />
                <WelcomeCard />
            </div>
        );
    }

    return (
        <div className="profesional-data-view">
            {<ProfileStep2 />}
            <WelcomeCard />
        </div>
    );
};
